export default {
  APPROVED: `Approved`,
  ACKNOWLEDGED: `Acknowledged`,
  IN_PROGRESS: `Pending review`,
  JUSTIFIED: `Justified`,
  UNJUSTIFIED: `Unjustified`,
  REFUSED: `Refused`,
  CANCELLED: `Cancelled`,
  APPROVAL_REQUIRED: `Approval required`,
  CHANGES_REQUESTED: `Changes requested`
}
